// export const customStyles = {
//     table: {
//         style: {
//           border: '1px solid #C8D6E6', // Border around the entire table
//           borderRadius: '0px', // Rounded corners for the table
//           overflow: 'hidden', // Prevent content overflow if border is rounded
//         },
//       },
//     headCells: {
//       style: {
//         backgroundColor: '#EAEDF2', // Green background for the header
//         color: 'black', // White text color
//         fontWeight: 'semi-bold', // Bold text
//         fontSize: '15px', // Font size
//         padding: '6px 10px', // Padding around the header cells
//       },
//     },
//     cells: {
//       style: {
//         fontSize: '13px', // Font size for table cells
//         padding: '8px', // Padding around cells
//         fontWeight: 'semibold', 
        
//       },
//     },
//   };

export const customStyles = {

    
  table: {
      style: {
          // border: '1px solid #C8D6E6', // Border around the entire table
          borderRadius: '6px', // Rounded corners for the table
          overflow: 'hidden',
          borderLeft: "1px solid #E0E7F0",
          borderTop: "1px solid #E0E7F0",
          borderRight: "1px solid #E0E7F0",
          borderBottom: "1px solid #E0E7F0",
           // Prevent content overflow if border is rounded
      },
  },
  headCells: {
      style: {
          backgroundColor: '#EAEDF2', // Green background for the header
          color: '#1B2A3D', // White text color
          fontWeight: '600', // Bold text
          fontSize: '16px', // Font size
          padding: '14px 20px',
          borderRight: "1px solid #C8D6E6",
          fontFamily:"Montserrat",
          fontSize:'16px',
          //height:'48px',
          // Padding around the header cells
      },
  },
 
  cells: {
      style: {
          fontSize: '14px', // Font size for table cells
          padding: '20px', // Padding around cells
          fontWeight: 500,
          height:"auto",
          fontFamily:"Montserrat",
          color: "#373737",
      },
  },
};



export const customStylesTrialStatus = {
    table: {
        style: {
            // border: '1px solid #C8D6E6', // Border around the entire table
            borderRadius: '6px', // Rounded corners for the table
            overflow: 'hidden',
            borderLeft: "1px solid #E0E7F0",
            borderTop: "1px solid #E0E7F0",
            borderRight: "1px solid #E0E7F0",
            borderBottom: "1px solid #E0E7F0",
             // Prevent content overflow if border is rounded
        },
    },
    headCells: {
        style: {
            backgroundColor: '#EAEDF2', // Green background for the header
            color: '#1B2A3D', // White text color
            fontWeight: '600', // Bold text
            fontSize: '16px', // Font size
            padding: '14px 10px',
            borderRight: "1px solid #C8D6E6",
            fontFamily:"Montserrat",
            fontSize:'16px',
            //height:'48px',
            // Padding around the header cells
        },
    },
   
    cells: {
        style: {
            fontSize: '14px', // Font size for table cells
            padding: '20px 10px', // Padding around cells
            fontWeight: 500,
            height:"auto",
            fontFamily:"Montserrat",
            color: "#373737",
        },
    },
  };